import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3ffafd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment-icon" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["comment", { "answer": _ctx.answer, "p-man": _ctx.pMan, "b-man": _ctx.bMan, "dog": _ctx.dog, "picnic-girl": _ctx.picnicGirl, "kote": _ctx.kote }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.text), 1),
    _hoisted_2
  ], 2))
}